import { useState } from 'react'
import { useView } from '@10000/react'
import { uuid } from '@10000/common'
import { SettingsLayout } from '../'
import { AddPill, Avatar, Body, Box, Input, ItemPill } from '../../widgets'
import { Organisation } from './'

export const Organisations = ({ goBackToSettingsMenu }) => {
  const { organisations = [] } = useView('tenant')
  const [search, setSearch] = useState('')
  const [selectedOrganisation, setSelectedOrganisation] = useState()

  return selectedOrganisation === undefined
    ? <SettingsLayout
        gap={16}
        title="Organisations"
        onBackButtonClick={goBackToSettingsMenu}
        backButtonMobileOnly
      >
        <Input dark leftIcon="Search" value={search} onChange={(e) => setSearch(e.target.value)}/>

        {organisations.filter(organisation => !search || organisation?.name.toLowerCase().includes(search.toLowerCase()))
          .map(({ name, avatar, id }, index) =>
            <ItemPill
              action={avatar === undefined}
              index={index}
              key={index}
              blackListBackgrounds={['white']}
              onClick={() => setSelectedOrganisation(id)}
            >
              <Box fullWidth alignItems="center" gap={8}>
                <Avatar size="small" index={avatar} mode="company"/>
                <Box fullWidth>
                  <Body bold align="left">{name ? name : 'Unnamed'}</Body>
                </Box>
                <Body underline alt bold size={12}>Edit</Body>
              </Box>
            </ItemPill>
          )
        }
        <AddPill text="Add new" onClick={() => setSelectedOrganisation(uuid())}/>
      </SettingsLayout>
    : <Organisation organisationId={selectedOrganisation} onClose={() => setSelectedOrganisation(undefined)}/>
}